import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type QrCountdownProps = {
  expiresAtMs: number;
  lifetimeMs: number;
};

/**
 * Полоска и обратный отсчёт до истечения динамического кода — по макету.
 *
 * Тикает раз в секунду только пока смонтирован, то есть пока открыта шторка
 * и код динамический: у статичного срока нет, и таймер там не рисуется.
 */
export const QrCountdown = ({ expiresAtMs, lifetimeMs }: QrCountdownProps) => {
  const { t } = useTranslation();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);

    return () => window.clearInterval(timer);
  }, []);

  const leftMs = Math.max(expiresAtMs - now, 0);
  // round, не ceil: сразу после ответа осталось 59,9 с — «61 секунда» на
  // экране выглядела бы ошибкой при сроке жизни в 60.
  const seconds = Math.round(leftMs / 1000);
  const progress = lifetimeMs > 0 ? Math.min(leftMs / lifetimeMs, 1) : 0;

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="h-1.5 w-40 overflow-hidden rounded-full bg-[#e1e4e8]">
        <div
          className="h-full rounded-full bg-brand-green transition-[width] duration-1000 ease-linear"
          style={{ width: `${progress * 100}%` }}
        />
      </div>
      <p className="font-inter-tight text-caption-sm-medium text-text-tertiary">
        {t('seconds-left', { count: seconds })}
      </p>
    </div>
  );
};
